/*
 * @Author: M.D.
 * @Date: 2019-12-16 10:00:41
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
import axios from 'axios'
import Vue from '@/main'
import store from 'store'
import {
  USR_TOKEN
} from '@/util/const'

// create an axios instance
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 50000 // request timeout
})

request.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// request interceptor
request.interceptors.request.use(
  // 设置请求头
  config => {
    if (!config.headers['Token']) {
      config.headers['Token'] = store.get(USR_TOKEN)
    }
    // 请求前判断是否需要转成JSON
    if (config.data && config.data.isJson) {
      const params = new URLSearchParams()
      for (const key in config.data) {
        if (config.data.hasOwnProperty(key)) {
          params.append(key, config.data[key])
        }
      }
      config.data = params
    }
    // config.headers={
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // }

    return config
  },
  err => Promise.reject(err)
)

// response interceptor
request.interceptors.response.use(
  response => {
    if (response.config.url === 'order/goodsOrder/decideVip') {
      return response
    }
    // alert(response.data)

    const res = response.data

    if (res.statusCode === '1000') {
      Vue.$store.dispatch('userLogOut', Vue)
    } else if (res.statusCode === '300') {
      if (response.config.url == '/order/tGoods/cxsbzfjl') {
        return response
      }

      if (response.config.url == '/order/com/getQymc') {
        return response
      }
      if (response.config.url == '/order/tGoods/cxfxpgzfjl') {
        return response
      }
      Vue.$alert(`${res.message}`, '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        center: true
      })

      //return Promise.reject(new Error(`${res.statusCode}`))
      return response

      //   setTimeout(() => {
      //     window.location = '#/login/'
      //   }, 1500)
      // } else if (res.errno === 502) {
      //   Toast.fail('网站内部错误，请联系网站维护人员')
      //   return Promise.reject('error')
      // } if (res.errno === 401) {
      //   Toast.fail('参数不对')
      //   return Promise.reject('error')
      // } if (res.errno === 402) {
      //   Toast.fail('参数值不对')
      //   return Promise.reject('error')
      // } else if (res.errno !== 0) {
      //   // 非5xx的错误属于业务错误，留给具体页面处理
      //   return Promise.reject(response)
    } else if (res.statusCode === '200') {
      return response
    } else if (res.statusCode === '201') {
      return response
    } else {
      Vue.$alert(`${res.message}`, '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        center: true
      })
    }
  }, error => {
    if (error.response.config.url === '/order/tGoods/cxfxpgzfjl') {
      return Promise.reject(error)
    }


    if (error.response.config.url === '/order/tGoods/cxsbzfjl') {
      return Promise.reject(error)
    }

    Vue.$alert(`接口错误！错误代码 ${error.response.status}：${error.response.data.error}<br/> 错误信息：${error.response.data.message}`, ' 提示', {
      confirmButtonText: '确定',
      type: 'warning',
      center: true,
      dangerouslyUseHTMLString: true
    })
    return Promise.reject(error)
  })

export default request
